import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';
import Home from './components/Home';
import Tournaments from './components/Tournaments';
import TournamentDetails from './components/TournamentDetails';
import Terrains from './components/Terrains';
import Chat from './components/Chat';
import Elections from './components/Elections';
import cone from './assets/da2026/cone.png';

const NAV = [
  { to: '/', icon: 'ri-home-5-fill', label: 'Accueil' },
  { to: '/tournaments', icon: 'ri-trophy-fill', label: 'Tournois' },
  { to: '/elections', icon: 'ri-award-fill', label: 'Élections' },
];

const MobileNavBar = () => {
  const location = useLocation();
  const isActive = (path) =>
    path === '/tournaments'
      ? location.pathname === path || location.pathname.startsWith('/tournament/')
      : location.pathname === path;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50">
      <div className="max-w-md mx-auto relative flex justify-around items-end px-3 pt-3 pb-3 bg-gradient-to-b from-brand-orange to-brand-orange-deep shadow-[0_-10px_30px_rgba(217,83,26,0.30)]">
        <div className="absolute top-0 inset-x-0 h-[5px] hazard-dark opacity-60"></div>
        {NAV.map((item) => {
          const active = isActive(item.to);
          return (
            <Link key={item.to} to={item.to} className="flex-1 flex flex-col items-center justify-end gap-1 min-w-0">
              <span
                className={
                  active
                    ? 'w-14 h-14 -mt-8 rounded-2xl bg-white text-brand-orange border-4 border-brand-orange-deep shadow-[0_12px_22px_rgba(20,19,18,0.30)] flex items-center justify-center text-[26px]'
                    : 'h-10 flex items-center justify-center text-2xl text-white/80'
                }
              >
                <i className={item.icon}></i>
              </span>
              <span className={`text-[11px] leading-none ${active ? 'text-white font-bold' : 'text-white/80 font-semibold'}`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

// Bouton flottant du chat Nouq, juste au-dessus de la barre de navigation.
// Masque sur la page du chat elle-meme.
const ChatFab = () => {
  const location = useLocation();
  if (location.pathname === '/chat') return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 pointer-events-none">
      <div className="max-w-md mx-auto relative">
        <Link
          to="/chat"
          aria-label="Ouvrir le chat Nouq"
          className="pointer-events-auto absolute right-4 bottom-[6.5rem] w-14 h-14 rounded-full bg-white border-2 border-brand-orange shadow-[0_10px_26px_rgba(20,19,18,0.22)] flex items-center justify-center active:scale-95 transition-transform"
        >
          <img src={cone} alt="" aria-hidden="true" className="w-8 h-8 object-contain" />
          <span className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-brand-green border-2 border-white"></span>
        </Link>
      </div>
    </div>
  );
};

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-brand-paper text-brand-ink pb-24">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tournaments" element={<Tournaments />} />
          <Route path="/tournament/:id" element={<TournamentDetails />} />
          <Route path="/terrains" element={<Terrains />} />
          <Route path="/elections" element={<Elections />} />
          {/* La section s'appelait "Mes petits paris" : on garde l'ancienne URL. */}
          <Route path="/pronos" element={<Navigate to="/elections" replace />} />
          <Route path="/chat" element={<Chat />} />
        </Routes>
        <ChatFab />
        <MobileNavBar />
      </div>
    </Router>
  );
}

export default App;
